export default __webpack_public_path__ + "static/media/ios-compose.9c72b916.svg";